import { useHistory } from "react-router-dom"
import { Button, Card, Col, Divider, Row, Form, InputNumber } from "antd"
import axios from "axios"
import { useContext } from "react"
import { OrderContext } from "../Context/OrderContext"
import { ThemeContext } from "../Context/ThemeContext"
import { UserContext } from "../Context/UserContext"
import { WalletContext } from "../Context/WalletContext"

function FormPayment(){
    let history = useHistory()
    const [user,,,setDashboard] = useContext(UserContext) 
    const [theme] = useContext(ThemeContext)
    const [userOrder] = useContext(OrderContext)
    const [userWallet] = useContext(WalletContext)
    const [form] = Form.useForm() 

    setDashboard(false)

    const idOrder = userOrder[0].id

    let orderItem = userOrder[0]?.order_item
    
    let totalBarang = 0
    orderItem?.map(function(item){
        return totalBarang+=item.quantity
    })

    let namaBarang = []
    orderItem?.map(function(item){
        return namaBarang.push(item.product.name)
    })

    let totalHarga = 0
    orderItem?.map(function(item){
        return totalHarga+=item.product.price
    })
    

    const HandleTopup = () => {
        history.push(`/walletyan/topup`)
    }

    const onFinish = (values) => {
        console.log(values)
        axios.put(`https://backend-sportyan.vercel.app/api/order/${idOrder}`, {...values}, {headers: {"Authorization" : "Bearer "+ user.token}})
            .then(()=>{
                history.push("/cart")
                window.location.reload()
            })
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
      
    form.setFieldsValue({
        newBalance: userWallet.balance-totalHarga,
        income: totalHarga
    })
    const changeNameClass =  theme === 'dark' ? 'dark-nav' : theme === 'light' ? 'light-nav': ''
    
    return(
        <>
        <Divider className={changeNameClass} orientation="center" style={{fontSize: "30px"}}>
            PAYMENT
        </Divider>
        <div style={{marginTop: "50px"}}>
            <Row>
                <Col span={8}></Col>
                <Col span={8}>
                    <Card>
                        <h3>Ringkasan Belanja</h3>
                        <Row>
                            <Col span={14}>
                                Total Barang : 
                                <hr/>
                                Saldo Walletyan : <br/>
                                Harga : 
                                <hr/>
                                Balance :
                            </Col>
                            <Col span={10} style={{textAlign: "right"}}> 
                                {totalBarang} 
                                <hr/>
                                Rp. {userWallet.balance} <br/>
                                Rp. {totalHarga}
                                <hr/>
                                Rp. {userWallet.balance - totalHarga}
                            </Col>
                        </Row>
                    </Card>
                    <Form
                        name="basic"
                        form={form}
                        labelCol={{
                            span: 4,
                        }}
                        wrapperCol={{
                            span: 16,
                        }}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                    >
                        <Form.Item
                            style={{display: 'none'}}
                            label="newBalance"
                            name="newBalance"
                            >
                            <InputNumber />
                        </Form.Item>

                        <Form.Item
                            style={{display: 'none'}}
                            label="income"
                            name="income"
                            >
                            <InputNumber />
                        </Form.Item>

                        <Form.Item
                            wrapperCol={{
                                offset: 4,
                                span: 16,
                            }}
                            >
                             <Row style={{marginTop: "20px"}}>
                                <Col span={10}></Col>
                                <Col>
                                {userWallet.balance - totalHarga >= 0 ?
                                    <Button size="large" type="primary" htmlType="submit">
                                        Bayar
                                    </Button>
                                    :
                                    <Button size="large" type="danger" onClick={HandleTopup}>
                                        Topup
                                    </Button>
                                }                       
                                </Col>
                                <Col span={10}></Col>
                            </Row>
                        </Form.Item>
                    </Form>
                </Col>
                <Col span={8}></Col>
            </Row>

        </div>
        </>
    )
}

export default FormPayment